import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import Cookies from 'js-cookie'
import Backbtn from './elements/Backbtn'
import { Footer, Nav, Loader, Analytics } from './elements'

import { 
    spareBrandFetch,
    spareFetchBrand,
} from '../redux/actions'

class Partsbrand extends Component {

    constructor() {
        super()
        this.state = {
            isLogin: false,
            user: "",
            brands: [],
        }
    }

    componentWillMount() {
        if(Cookies.get('user')){
            this.setState({
                isLogin: true,
                user: JSON.parse(Cookies.get('user'))
            })
        } else {
            window.location = "/login"
        }
        this.props.spareBrandFetch()
        this.props.spareFetchBrand()
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.brands || nextProps.spares) {
            if (nextProps.spares) {
                const brands = []
                nextProps.brands.forEach(item => {
                    const temp = nextProps.spares.find(item2 => item2.brand_id === item.id)
                    if (temp) brands.push(item)
                });
                this.setState({ brands })
            }
        }
    }

    showBrands() {
        if(this.state.brands.length > 0) {
            return this.state.brands.map((item, index) => {
                return (
                    <div className="each-brand" key={++index}>
                        <Analytics />
                        <Link to={{ pathname: "/partsdetail", search: `brand_id=${item.id}`}}>
                            <img src={item.img} alt={item.title}/>
                        </Link>
                    </div>
                )
            })
        } else {
            return <Loader />
        }
    }

    render() { 
        if(!this.state.isLogin) return <div></div>
        return ( 
            <div className="page-partsbrand">
                <div className="partsbrand-header">
                    <Backbtn />
                    <div className="title">
                        <p>เลือกแบรนด์</p>
                    </div>
                    <Nav />
                </div>
                {/* <div className="partsbrand-banner container">
                    {(this.props.promoImg && <a href={this.props.promoUrl}>
                        <img src={this.props.promoImg} alt="โปรโมชั่นแอร์"/>
                    </a>)}
                </div> */}
                <div className="partsbrand-brand container">
                    {this.showBrands()}
                </div>
                <Footer />
            </div>
        )
    }
}
 
const mapStateToProps = ({ brand, spare }) => {
    return { 
        brands: brand.brands,
        spares: spare.spares,
    }
}
 
export default connect(mapStateToProps, { 
    spareBrandFetch, spareFetchBrand
})(Partsbrand)